import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  get,
} from 'lodash';
import {
  API,
  SidePanelContainer,
  SidePanelContent,
  SidePanelFooter,
  VibeCheckbox,
  VibeSplash,
  VibeButton,
  color,
} from 'vibeguide';
import AlertEmailSettings from './AlertEmailSettings';

class AlertNetworkConfig extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      configFetched: false,
      deviceRoaming: false,
      emailFlaggedLocations: false,
      recipients: [],
      suppressNotificationMinutes: 0,
    };
  }

  componentDidMount() {
    this.getConfig();
  }

  /**
   * When the email settings are changed
   */
  onUpdateEmailSettings = (data) => {
    this.setState(data);
  };

  onChangeSelect = ({
    name,
    checked,
  }) => {
    this.setState({
      [name]: checked,
    });
  };

  getConfig = async () => {
    const config = await API.Location.Alerts.Network.get();

    this.setState({
      configFetched: true,
      deviceRoaming: get(config, 'roaming.active', false),
      emailFlaggedLocations: get(config, 'emailNotification.emailFlaggedLocations', false),
      recipients: get(config, 'emailNotification.recipients', []),
      suppressNotificationMinutes: get(config, 'suppressNotificationMinutes', 0),
    });
  };

  save = async () => {
    const {
      onToast,
    } = this.props;

    const {
      deviceRoaming,
      emailFlaggedLocations,
      recipients,
      suppressNotificationMinutes,
    } = this.state;

    const data = {
      roaming: {
        active: deviceRoaming,
      },
      emailNotification: {
        emailFlaggedLocations,
        recipients,
      },
      suppressNotificationMinutes,
    };

    onToast({
      type: 'info',
      title: 'Saving...',
      allowClose: true,
    });

    const saveResponse = await API.Location.Alerts.Network.update(data);

    if (get(saveResponse, '[0].type') !== 'SYSTEMSETTING.UPDATED') {
      onToast({
        type: 'error',
        title: 'Error updating setting',
        timeout: 10,
        allowClose: true,
      });

      return;
    }

    onToast({
      type: 'success',
      title: 'Saved!',
      allowClose: true,
      delay: 500,
    });
  };

  render() {
    const {
      className,
    } = this.props;

    const {
      configFetched,
      deviceRoaming,
      emailFlaggedLocations,
      recipients,
      suppressNotificationMinutes,
    } = this.state;

    if (!configFetched) {
      return (
        <VibeSplash
          type="loading"
          size={64}
          style={{
            color: color.primary,
          }}
        />
      );
    }

    return (
      <SidePanelContainer className={classNames('AlertSidebarConfig', 'AlertNetworkConfig', className)}>
        <SidePanelContent>
          <div className="section">
            <div className="section-title">
              Send alert when:
            </div>

            <div className="section-content">
              <div className="setting">
                <VibeCheckbox
                  rootStyle={{
                    flexGrow: 1,
                  }}
                  name="deviceRoaming"
                  label="Device is roaming"
                  size={16}
                  color={color.success}
                  checked={deviceRoaming}
                  onChange={this.onChangeSelect}
                />
              </div>
            </div>
          </div>

          <AlertEmailSettings
            emailFlaggedLocations={emailFlaggedLocations}
            recipients={recipients}
            suppressNotificationMinutes={suppressNotificationMinutes}
            onUpdate={this.onUpdateEmailSettings}
          />
        </SidePanelContent>

        <SidePanelFooter>
          <VibeButton
            text="Save Changes"
            color="secondary"
            onClick={this.save}
          />
        </SidePanelFooter>
      </SidePanelContainer>
    );
  }
}

AlertNetworkConfig.propTypes = {
  className: PropTypes.string,
  onToast: PropTypes.func,
};

AlertNetworkConfig.defaultProps = {
  className: '',
  onToast: () => {},
};

export default AlertNetworkConfig;
